import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, AfterViewInit } from '@angular/core';
import { Subject, BehaviorSubject, merge } from 'rxjs';
import { DataSource } from '@angular/cdk/table';
import { takeUntil, tap } from 'rxjs/operators';
import { MatPaginator, MatSort, MatDialog, MatSnackBar } from '@angular/material';
var RecommenderListComponent = /** @class */ (function () {
    function RecommenderListComponent(_recommenderService, _matDialog, _matSnackBar, _translate, _translationLoader, _companyService, dateAdapter) {
        this._recommenderService = _recommenderService;
        this._matDialog = _matDialog;
        this._matSnackBar = _matSnackBar;
        this._translate = _translate;
        this._translationLoader = _translationLoader;
        this._companyService = _companyService;
        this.dateAdapter = dateAdapter;
        this.displayedColumns = ['name', 'date_of_birth', 'email', 'created_at'];
        this.totalPages = 2;
        this.totalElements = 0;
        this.sortField = 'created_at';
        this.sordOrder = 'desc';
        this.pageSize = 10;
        this.lang = 'sr';
        this._unsubscribeAll = new Subject();
        this.dateAdapter.setLocale('en-gb');
    }
    RecommenderListComponent.prototype.getTranslations = function () {
        var _this = this;
        this._translationLoader.getLastLang()
            .then(function (response) {
            _this.lang = response['code'];
            _this._translationLoader.getTranslations(_this.lang, '25');
            _this.dateAdapter.setLocale(_this.lang);
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
        }, function (err) {
        });
    };
    RecommenderListComponent.prototype.updateDataDateFormat = function (data) {
        if (data && data.length > 0) {
            console.log(data);
            data.forEach(function (element) {
                var d = new Date(element.extra_date);
                var datestring = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear() + '  ' +
                    ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + ':' + ('0' + d.getSeconds()).slice(-2);
                element.extra_date = element.extra_date ? datestring : '';
                d = new Date(element.created_at);
                datestring = d.getDate() + '/' + (d.getMonth() + 1) + '/' + d.getFullYear() + '  ' +
                    ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2) + ':' + ('0' + d.getSeconds()).slice(-2);
                element.created_at = element.created_at ? datestring : '';
            });
        }
        return data;
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------
    RecommenderListComponent.prototype.loadRecommenderPage = function () {
        this.dataSource.loadRecommender(this.paginator.pageIndex + 1, this.paginator.pageSize, this.sort.active || 'created_at', this.sort.direction || 'desc', '', this.company.id);
    };
    // -----------------------------------------------------------------------------------------------------
    // @ Lifecycle hooks
    // -----------------------------------------------------------------------------------------------------
    RecommenderListComponent.prototype.ngOnInit = function () {
        var _this = this;
        console.log('here');
        this.dataSource = new FilesDataSource(this._recommenderService);
        this._companyService.getActiveCompany()
            .then(function (response) {
            _this.company = response;
            console.log(_this.company);
        })
            .catch(function (err) { return Promise.reject(err); })
            .then(function () {
            _this.loadRecommenderPage();
        }, function (err) {
        });
        this._recommenderService.onRecommendationsChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            _this.totalPages = Math.floor(response.total / _this.paginator.pageSize) + 1;
            _this.totalElements = response.total;
            // if (firstRun) {
            //     firstRun = false;
            // } else {
            _this.dataSource.setData(response.data);
            // }
        });
        this._translationLoader.onLangChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (value) {
            _this.getTranslations();
        });
        this._companyService.onCompanyChanged
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe(function (response) {
            if (_this.company) {
                if (_this.company.id !== _this._companyService.activeCompany.id ? _this._companyService.activeCompany.id : response.id) {
                    _this.company = _this._companyService.activeCompany;
                    _this.loadRecommenderPage();
                }
            }
        });
        this.getTranslations();
    };
    RecommenderListComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        // reset the paginator after sorting
        this.sort.sortChange.subscribe(function () { return _this.paginator.pageIndex = 0; });
        // on sort or paginate events, load a new page
        merge(this.sort.sortChange, this.paginator.page)
            .pipe(tap(function () { return _this.loadRecommenderPage(); }))
            .pipe(takeUntil(this._unsubscribeAll))
            .subscribe();
    };
    RecommenderListComponent.prototype.ngOnDestroy = function () {
        // Unsubscribe from all subscriptions
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    };
    return RecommenderListComponent;
}());
export { RecommenderListComponent };
// Custom Angular CDK Data Source
var FilesDataSource = /** @class */ (function (_super) {
    tslib_1.__extends(FilesDataSource, _super);
    /**
     * Constructor
     *
     * @param {RecommenderService} _recommenderService
     */
    function FilesDataSource(_recommenderService) {
        var _this = _super.call(this) || this;
        _this._recommenderService = _recommenderService;
        _this.recommenderSubject = new BehaviorSubject([]);
        _this.loadingSubject = new BehaviorSubject(false);
        _this.loading$ = _this.loadingSubject.asObservable();
        return _this;
    }
    FilesDataSource.prototype.connect = function () {
        return this.recommenderSubject.asObservable();
    };
    FilesDataSource.prototype.disconnect = function () {
        this.recommenderSubject.complete();
        this.loadingSubject.complete();
    };
    FilesDataSource.prototype.setData = function (data) {
        this.recommenderSubject.next(data);
        this.loadingSubject.next(false);
    };
    FilesDataSource.prototype.loadRecommender = function (page, limit, orderBy, order, search, company) {
        var _this = this;
        if (page === void 0) { page = 1; }
        if (limit === void 0) { limit = 20; }
        if (orderBy === void 0) { orderBy = 'created_at'; }
        if (order === void 0) { order = 'desc'; }
        if (search === void 0) { search = ''; }
        if (company === void 0) { company = 1; }
        this.loadingSubject.next(true);
        this._recommenderService.listRecommendations(company, page, limit, orderBy, order, search).then(function (response) {
            _this.recommenderSubject.next(response.data);
            _this.loadingSubject.next(false);
        });
    };
    return FilesDataSource;
}(DataSource));
export { FilesDataSource };
